var Announcer = /** @class */ (function () {
    function Announcer(dataHook) {
        this.SILENT_SUFFIX = '.';
        var announcerElement = document.createElement('div');
        var OFFSCREEN = "border: 0;clip: rect(0 0 0 0);clip: rect(0, 0, 0, 0); height: 1px;margin: -1px;overflow: hidden;padding: 0; width: 1px;position: absolute;";
        announcerElement.setAttribute('data-hook', dataHook);
        announcerElement.setAttribute('style', OFFSCREEN);
        announcerElement.setAttribute('role', 'log');
        announcerElement.setAttribute('aria-live', 'assertive');
        this.announcerElement = document.body.appendChild(announcerElement);
    }
    Announcer.prototype.announce = function (text) {
        if (this.announcerElement.innerText === text) {
            this.announcerElement.innerText += this.SILENT_SUFFIX;
        }
        else {
            this.announcerElement.innerText = text;
        }
    };
    Announcer.prototype.cleanup = function () {
        document.body.removeChild(this.announcerElement);
    };
    return Announcer;
}());
export { Announcer };
//# sourceMappingURL=announcer.js.map